import { Map } from 'immutable';

import {
  CHECKOUT_PREVIEW,
  RESET_CHECKOUT_PREVIEW,
  RESET_COUPON_CODE,
  SAVE_COUPON_CODE,
  SET_APPLYING_COUPON,
} from './types';

const initialState = Map({
  // We need this value in order to distinguish between the user consciously applying coupon code
  // and the coupon code being inherited from a previous filling of the form:
  applyingCoupon: false,
  checkoutPreview: {
    balance: 0,
    discount: 0,
    subtotal: 0,
    total: 0,
    tax: 0,
  },
  couponCode: null,
  isLoading: false,
  isPreviewLoaded: false,
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHECKOUT_PREVIEW.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('checkoutPreview', payload)
          .set('isLoading', false)
          .set('isPreviewLoaded', true);
      });
    case CHECKOUT_PREVIEW.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('checkoutPreview', initialState.get('checkoutPreview'));
      });
    case CHECKOUT_PREVIEW.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('isPreviewLoaded', false);
      });
    case SET_APPLYING_COUPON:
      return state.set('applyingCoupon', !!payload);
    case SAVE_COUPON_CODE:
      return state.set('couponCode', payload);
    case RESET_COUPON_CODE:
      return state.set('couponCode', initialState.get('couponCode'));
    case RESET_CHECKOUT_PREVIEW:
      return state.set('isPreviewLoaded', false);
    default:
      return state;
  }
};
